import { forwardRef, Input } from '@angular/core';
import { RangeFilter } from '../models/range.model';
import { Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'hr-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangePickerComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class DateRangePickerComponent implements OnInit, ControlValueAccessor {
  @Input()
  public style: string;

  @Input()
  public dateFormat: string;

  @Input()
  public minStartDate: string;

  @Input()
  public maxStartDate: string;

  @Input()
  public minEndDate: string;

  @Input()
  public maxEndDate: string;

  public notifyChange: any = () => {};

  public get from() {
    return this.range.from;
  }
  public set from(val) {
    this.range.from = val; //this._from;
    this.notifyChange(this.range);
  }

  public get to() {
    return this.range.to;
  }

  public set to(val) {
    this.range.to = val;
    this.notifyChange(this.range);
  }

  writeValue(obj: any): void {
    this.range.from = obj && obj.from;
    this.range.to = obj && obj.to;
  }

  registerOnChange(fn: any): void {
    this.notifyChange = fn;
  }

  registerOnTouched(fn: any): void {
    //throw new Error('Method not implemented.');
  }

  setDisabledState(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

  public range: RangeFilter<Date>;

  constructor() {
    this.range = new RangeFilter(null, null);
  }

  ngOnInit() {}
}
